var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobToolsBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "row1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error_transparent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64,.3C28.7.3,0,28.8,0,64s28.7,63.7,64,63.7,64-28.5,64-63.7S99.3.3,64,.3Zm0,121c-31.8,0-57.6-25.6-57.6-57.3S32.2,6.7,64,6.7s57.6,25.7,57.6,57.3-25.8,57.3-57.6,57.3Zm21.9-73.2l-4.9-4.8c-.9-.9-2.3-.9-3.2,0l-13.8,13.7-13.8-13.7c-.9-.9-2.3-.9-3.2,0l-4.9,4.8c-.9.9-.9,2.3,0,3.2l13.8,13.7-13.8,13.8c-.9.9-.9,2.3,0,3.2l4.9,4.8c.9.9,2.3.9,3.2,0l13.8-13.7,13.8,13.7c.9.9,2.3.9,3.2,0l4.9-4.8c.9-.9.9-2.3,0-3.2l-13.8-13.8,13.8-13.7c.9-.9.9-2.3,0-3.2Z",
    fill: "#fff",
    strokeWidth: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobToolsBad);
export default __webpack_public_path__ + "static/media/job_tools_bad.aa291d0e2c0a9935e21797d85097a763.svg";
export { ForwardRef as ReactComponent };